export const MOBILE_BREAKPOINT_NUMBER = 1090;
export const MOBILE_BREAKPOINT = `${MOBILE_BREAKPOINT_NUMBER}px`;

/** Narrow phones: live-map status strip shows counts only (no status labels). */
export const COMPACT_MOBILE_BREAKPOINT_NUMBER = 520;
export const COMPACT_MOBILE_BREAKPOINT = `${COMPACT_MOBILE_BREAKPOINT_NUMBER}px`;

/** Extra-narrow phones: dense header toolbar (sync with shared NARROW_MOBILE_BREAKPOINT_NUMBER). */
export const NARROW_MOBILE_BREAKPOINT_NUMBER = 440;
export const NARROW_MOBILE_BREAKPOINT = `${NARROW_MOBILE_BREAKPOINT_NUMBER}px`;

/** Row-count bulk mode: hide starred below this width (sync with shared). */
export const HEADER_STARRED_ROW_COUNT_HIDE_BREAKPOINT_NUMBER = 780;
export const HEADER_STARRED_ROW_COUNT_HIDE_BREAKPOINT = `${HEADER_STARRED_ROW_COUNT_HIDE_BREAKPOINT_NUMBER}px`;

/**
 * WCAG 2.1 AA minimum touch/click target, in px.
 *
 * Applied as a hit area rather than as a visual size: a 44px icon inside a dense card or a
 * transcript row would dominate it, and the success criterion measures what is clickable, not
 * what is drawn.
 */
export const TOUCH_TARGET_MIN_SIZE = 44;

/** Half the target, for centring a hit area on the control it belongs to. */
export const TOUCH_TARGET_HALF_SIZE = TOUCH_TARGET_MIN_SIZE / 2;
